module.exports = __webpack_public_path__ + "media/images/illustration/undraw_location_review_dmxd-cea22d6447612836aec53a2a4e16d934.svg";